// extracted by mini-css-extract-plugin
export var loadingShimmer = "_ra-2";
export var messageContent = "_ra-0";
export var messagesScroll = "_ra-1";
export var shimmer = "_ra-3";
export var shimmerW100 = "_ra-4";
export var shimmerW70 = "_ra-8";
export var shimmerW80 = "_ra-7";
export var shimmerW85 = "_ra-6";
export var shimmerW90 = "_ra-5";